<template>
  <div>
    <div>
      <v-app-bar color="deep-purple accent-4" dense dark>
        <router-link :to="{ name: 'clinics' }">
          <v-icon medium>mdi-home</v-icon>
        </router-link>
        <v-spacer></v-spacer>
        <v-toolbar-title>GPA Medical Insurance</v-toolbar-title>

        <v-spacer></v-spacer>
        <!--
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
-->

        <router-link :to="{ name: 'sign-out' }">
          <v-list-item-title>Logout</v-list-item-title>
        </router-link>
      </v-app-bar>
    </div>
    <slot />
    <v-footer color="indigo" app>
      <v-spacer></v-spacer>
      <span class="white--text"> You're logged in as: {{ userName }} </span>
    </v-footer>
  </div>
</template>
<script>
import JwtService from "@/services/jwt.service";
export default {
  name: "cliniclayout",
  data: () => ({
    clinic_name: []
  }),
  computed: {
    userName() {
      return JwtService.getUser()
        ? JwtService.getUser()["user_firstname"] +
            " " +
            JwtService.getUser()["user_lastname"]
        : ""; // this.$store.getters["users/userName"];
    }
  }
};
</script>
<style scoped>
a {
  color: white;
  text-decoration: none;
}
</style>
